export const FETCH_IDEAS = 'FETCH_IDEAS';
export const FETCH_IDEAS_SUCCESS = 'FETCH_IDEAS_SUCCESS';
export const FETCH_IDEAS_FAILED = 'FETCH_IDEAS_FAILED';

export const SET_IDEAS_MENU = 'SET_IDEAS_MENU';
